import { render, staticRenderFns } from "./DeleteApptModal.vue?vue&type=template&id=f6363552"
import script from "./DeleteApptModal.vue?vue&type=script&lang=js"
export * from "./DeleteApptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports